import { _BASE_URL } from './Constants';

const BASE = _BASE_URL + '/settings';

export const SETTINGS_ROUTES = {
  tripService: {
    list: () => `${BASE}/trip-service`,
    get: (id) => `${BASE}/trip-service/${id}`,
    create: () => `${BASE}/trip-service`,
    delete: () => `${BASE}/trip-service/delete`,
  },

  branch: {
    list: () => `${BASE}/branch`,
    get: (id) => `${BASE}/branch/${id}`,
    create: () => `${BASE}/branch`,
    delete: () => `${BASE}/branch/delete`,
  },

  hangaround: {
    list: () => `${BASE}/hangaround`,
    get: (id) => `${BASE}/hangaround/${id}`,
    create: () => `${BASE}/hangaround`,
    delete: () => `${BASE}/hangaround/delete`,
  },

  knownby: {
    list: () => `${BASE}/knownby`,
    get: (id) => `${BASE}/knownby/${id}`,
    create: () => `${BASE}/knownby`,
    delete: () => `${BASE}/knownby/delete`,
  },

  residence: {
    list: () => `${BASE}/residence`,
    get: (id) => `${BASE}/residence/${id}`,
    create: () => `${BASE}/residence`,
    delete: () => `${BASE}/residence/delete`,
  },

  education: {
    list: () => `${BASE}/education`,
    get: (id) => `${BASE}/education/${id}`,
    create: () => `${BASE}/education`,
    delete: () => `${BASE}/education/delete`,
  },

  profession: {
    list: () => `${BASE}/profession`,
    get: (id) => `${BASE}/profession/${id}`,
    create: () => `${BASE}/profession`,
    delete: () => `${BASE}/profession/delete`,
  },

  skill: {
    list: () => `${BASE}/skill`,
    get: (id) => `${BASE}/skill/${id}`,
    create: () => `${BASE}/skill`,
    delete: () => `${BASE}/skill/delete`,
  },

  work: {
    list: () => `${BASE}/work`,
    get: (id) => `${BASE}/work/${id}`,
    create: () => `${BASE}/work`,
    delete: () => `${BASE}/work/delete`,
  },

  nationality: {
    list: () => `${BASE}/nationality`,
    get: (id) => `${BASE}/nationality/${id}`,
    create: () => `${BASE}/nationality`,
    delete: () => `${BASE}/nationality/delete`,
  },

  language: {
    list: () => `${BASE}/language`,
    get: (id) => `${BASE}/language/${id}`,
    create: () => `${BASE}/language`,
    delete: () => `${BASE}/language/delete`,
  },
};

export default SETTINGS_ROUTES;

const TRIP_BASE = _BASE_URL + '/trip';

export const TripRoutes = {
  /* =======================
   * Trip Types
   * ======================= */
  tripTypesList: `${TRIP_BASE}/types`,
  getTripType: (id) => `${TRIP_BASE}/type/${id}`,
  addTripType: `${TRIP_BASE}/type`,
  deleteTripType: `${TRIP_BASE}/type/delete`,

  /* =======================
   * Reminders
   * ======================= */
  remindersList: `${TRIP_BASE}/reminder`,
  getReminder: (id) => `${TRIP_BASE}/reminder/${id}`,
  addReminder: `${TRIP_BASE}/reminder`,
  sendReminder: `${TRIP_BASE}/reminder/send`,
  deleteReminder: `${TRIP_BASE}/reminder/delete`,

  /* =======================
   * Supervisor
   * ======================= */
  supervisorsList: `${TRIP_BASE}/supervisor`,

  /* =======================
   * Clients
   * ======================= */
  addClient: `${TRIP_BASE}/client`,
  deleteClient: `${TRIP_BASE}/client/delete`,
  getClient: (id) => `${TRIP_BASE}/client/${id}`,

  /* =======================
   * Client Members
   * ======================= */
  clientMembersList: `${TRIP_BASE}/client-member`,
  getClientMember: (id) => `${TRIP_BASE}/client-member/${id}`,
  addClientMember: `${TRIP_BASE}/client-member`,
  deleteClientMember: `${TRIP_BASE}/client-member/delete`,

  /* =======================
   * Projects
   * ======================= */
  projectsList: `${TRIP_BASE}/project`,
  getProject: (id) => `${TRIP_BASE}/project/${id}`,
  addProject: `${TRIP_BASE}/project`,
  deleteProject: `${TRIP_BASE}/project/delete`,

  /* =======================
   * Country
   * ======================= */
  countriesList: `${TRIP_BASE}/country`,

  /* =======================
   * Trips
   * ======================= */
  tripsList: `${TRIP_BASE}`,
  addTrip: `${TRIP_BASE}/addTrip`,
  getTripById: (id) => `${TRIP_BASE}/${id}`,
  getTripByIdAndYear: (id, year) => `${TRIP_BASE}/${id}/${year}`,
  getUserTrips: (userId) => `${TRIP_BASE}/user/${userId}`,

  /* =======================
   * Filters
   * ======================= */
  updateTripFilter: `${TRIP_BASE}/update-filter`,

  /* =======================
   * Misc / Backwards compatible
   * ======================= */
  getTripInactive: `${TRIP_BASE}/inactive`,
  deleteTrip: `${TRIP_BASE}/deleteTrip`,
  uploadDoc: `${TRIP_BASE}/uploadDoc`,
  deleteFiles: `${TRIP_BASE}/deleteFiles`,
  clientsList: `${TRIP_BASE}/client`,
};
